import { Link } from "react-router-dom";

export default function CaseCard({ c }) {
  return (
    <Link className="case-card" to={`/cases/${c.slug}`}>
      <div className={`case-img${c.isCover ? " is-cover" : ""}`}>{c.cover}</div>
      <p className="case-meta">{c.meta}</p>
      <h3>{c.title}</h3>
      <div className="case-tags">
        {c.tags.map((t) => (
          <span key={t}>{t}</span>
        ))}
      </div>
    </Link>
  );
}
